import { Field } from "react-final-form";
import { LoadingButton } from "../../../../components/LoadingButton";
import { required } from "../../../../util/validators";
import { AdministrateSelectInput } from "../../../components/inputs/AdministrateSelectInput";
import { BlankableField } from "../../../../components/inputs/final_form/BlankableField";
import { Switch } from "../../../../components/inputs/final_form/Switch";
import { OnChange } from "react-final-form-listeners";
import { FormText } from "reactstrap";
import { TextInput } from "../../../../components/inputs/final_form/TextInput";

export const CustomerSuccessAutoAssignmentForm = ({ handleSubmit, submitting, values, form }) => {
  return (
    <>
      <Field
        className="mb-3"
        component={Switch}
        type="checkbox"
        label="Assign To Customer Success"
        name="assignToCustomerSuccess"
        defaultValue={true}
      />

      <Field className="mb-3" component={Switch} type="checkbox" label="Escalate Case" name="escalateCase" defaultValue={false} />

      <Field className="mb-3" component={Switch} type="checkbox" label="Don't Add Task" name="dontAddTask" defaultValue={false} />

      <Field
        className="mb-3"
        component={Switch}
        type="checkbox"
        label="Add Automatic Reply If Case Task Is Not Yet Due"
        name="addAutoReplyForNotDueTask"
        defaultValue={false}
      />

      {values.addAutoReplyForNotDueTask && (
        <BlankableField
          validate={required}
          required
          label="Canned Comment to Add"
          component={TextInput}
          name="cannedComment"
          placeholder="This case will be worked shortly"
        />
      )}

      <OnChange name="addAutoReplyForNotDueTask">
        {
          // When value is false, reset cannedComment
          (value) => !value && form.change("cannedComment", null)
        }
      </OnChange>

      <Field
        component={AdministrateSelectInput}
        resourceUrl="/admin/enums/statuses_for_round_robin.json"
        label="Status"
        name="status"
        labelKey="label"
        valueKey="id"
        validate={required}
        required
      >
        <FormText>Only PA non-terminal and PA/BI non-received statuses can be selected.</FormText>
      </Field>

      <Field
        component={AdministrateSelectInput}
        resourceUrl="/admin/enums/comment_type_options.json"
        label="Comment Type"
        name="commentType"
        labelKey="label"
        valueKey="id"
        validate={required}
        required
      >
        <FormText>Other Comment Types do trigger different configurations.</FormText>
      </Field>

      <BlankableField label="Comment Regex" component={TextInput} name="commentRegex" placeholder="\bstatus\s+of\s+cases\b">
        <FormText>If the comment matches this regex, we will take action.</FormText>
      </BlankableField>

      <LoadingButton loading={submitting} onClick={handleSubmit} disabled={submitting}>
        Submit
      </LoadingButton>
    </>
  );
};
